import ErrorIcon from '@atlaskit/icon/glyph/error';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import React from 'react';
import MotionWrapper from '../../../common/motion-wrapper';
const containerStyles = xcss({
  all: 'unset',
  borderRadius: 'border.radius',
  margin: 'space.100',
  marginBottom: 'space.0',
  lineHeight: '20px',
  padding: 'space.075',
  paddingInline: 'space.100',
  width: '100%',
  ':empty': {
    display: 'none'
  }
});
const errorStyles = xcss({
  backgroundColor: 'color.background.danger'
});
const titleStyles = xcss({
  color: 'color.text.subtle',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '16px'
});
const getIcon = appearance => {
  switch (appearance) {
    case 'error':
      return /*#__PURE__*/React.createElement(ErrorIcon, {
        primaryColor: "var(--ds-icon-danger, #C9372C)",
        label: "Error",
        size: "small",
        testId: "action-error-icon"
      });
    default:
      return null;
  }
};
export const ActionFooter = ({
  message,
  testId
}) => {
  if (!message) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    testId: `${testId}-footer`,
    xcss: [containerStyles, message.appearance === 'error' && errorStyles]
  }, /*#__PURE__*/React.createElement(MotionWrapper, {
    isFadeIn: true,
    show: true,
    showTransition: true
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "start",
    grow: "fill",
    space: "space.050"
  }, message.icon || getIcon(message.appearance), /*#__PURE__*/React.createElement(Box, {
    xcss: titleStyles
  }, message.title))));
};